module.exports = __webpack_public_path__ + "static/media/mideporte-blog.21852bb4.png";